module.exports = __webpack_public_path__ + "img/home_active.b5f481f1.svg";